// extracted by css-extract-rspack-plugin
export default {"Visual":"ModelsSection-module__Visual__Ekjs0"};